module.exports = __webpack_public_path__ + "static/media/faq3.90092ba2.webp";